import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, of, forkJoin, Subscription } from 'rxjs';
import { QuoteRequestState } from 'src/app/shared/models/quote-request-state';
import { WizardService } from 'src/app/wizard-bar/services/wizard.service';
import { DateConstants } from '@app/constants/date-constants';
import { QuoteRequestService } from '@app/shared/services/quote-request.service';
import { Store } from '@ngrx/store';
import { SetQuote } from '@quoting/state/actions/quoting-module.actions';
import { AppState } from '@app/state/app.state';
import { SetCommodityType } from '@utility-information/state/actions/utility-information.actions';
import { loggedInUtilityHubIdentitySelector } from '@app/state/app.selectors';

@Component({
  selector: 'app-custom-youre-done',
  templateUrl: './custom-youre-done.component.html',
  styleUrls: ['./custom-youre-done.component.scss'],
})
export class CustomYoureDoneComponent implements OnInit, OnDestroy {
  public dateFormat = DateConstants.LOCALE_FORMAT_SHORT();

  public quoteRequestId: number;
  public quoteRequestState: QuoteRequestState;
  public youreDone: any;
  loadSubscription$: Subscription;
  routeSubscription$: Subscription;
  uhIdentity$: Subscription;
  quote$: Subscription;

  constructor(
    public quoteService: QuoteRequestService,
    private route: ActivatedRoute,
    private wizardService: WizardService,
    private store: Store<AppState>) {}

  ngOnDestroy(): void {
    this.loadSubscription$?.unsubscribe();
    this.routeSubscription$?.unsubscribe();
    this.uhIdentity$?.unsubscribe();
    this.quote$?.unsubscribe();
  }

  ngOnInit(): void {
    this.wizardService.bindStep(this.route, () => this.save());
    this.routeSubscription$ = this.route.params.subscribe((x) => {
      if (!isNaN(x.quoteRequestId)) {
        this.quoteRequestId = Number(x.quoteRequestId);
        this.load();
      }
    });
  }

  public showContent(statuses: string[]) {
    // QuoteGenerated
    // OfferRejected
    // OfferAccepted
    return statuses.some((f) => f === this.quoteRequestState.status);
  }

  private load() {
    this.loadSubscription$ = forkJoin({
      state: this.quoteService.getQuoteRequestState(this.quoteRequestId),
      quote: this.quoteService.getSavedQuote(this.quoteRequestId),
      youreDone: this.quoteService.getYoureDone(this.quoteRequestId),
    }).subscribe((res) => {
      this.youreDone = res.youreDone;
      this.quoteRequestState = res.state;
      this.uhIdentity$ = this.store.select(loggedInUtilityHubIdentitySelector).subscribe((user) => {
        const updatedQuote = { ...res.quote, youreDone: res.youreDone };
        this.store.dispatch(new SetCommodityType(this.quoteRequestId.toString(), this.quoteRequestState.commodity));
        this.store.dispatch(new SetQuote(
          updatedQuote,
          user,
          res.state.hasIDontKnows,
        ));
      });
    });
  }

  public save(): Observable<any> {
    return of(true);
  }

  public next() {
    this.wizardService.next();
  }

  public back() {
    this.wizardService.previous();
  }
}
